import { Col, Row } from "react-bootstrap";
import React from "react";
import { FaTimes } from "react-icons/fa";
import styles from "./cartItemRow.module.scss";
import { ImageWrapper } from "@/common/components/Images/ImageWrapper";
import { CheckoutCartConfigurator } from "@/components/Cart/CartForm/CartForm";
import { getConfiguratorImage } from "@/common/helpers/fetch.helpers";
import FloatingProductsConfigurator from "@/components/ConfiguratorsProducts/FloatingProductsConfigurator";

export interface CartItemRowData {
    item: CheckoutCartConfigurator;
    configuratorDeleteCallBack: (configuratorCode: string) => void;
}

const ConfiguratorItemRow = React.memo(({ item, configuratorDeleteCallBack }: CartItemRowData) => {
    const handleDeleteItem = (configuratorCode: string) => {
        configuratorDeleteCallBack(configuratorCode);
    };

    const calculateUnitPrice = () => {
        let totalPriceConfigurator = 0;
        for (const cartProduct of item.cartProducts) {
            totalPriceConfigurator +=
                Number(cartProduct.specialPriceWithVat) !== 0 ? Number(cartProduct.specialPriceWithVat) : Number(cartProduct.priceWithVat);
        }

        return totalPriceConfigurator;
    };

    const unitPrice = calculateUnitPrice();

    return (
        <Row className={styles.productRow}>
            <Col xs={12} md={2}>
                <ImageWrapper width={100} height={100} url={getConfiguratorImage(item.configurator)} title={item.configurator.name} />
            </Col>
            <Col xs={12} md={4}>
                <div className={styles.name}>{item.configuratorName}</div>
                <FloatingProductsConfigurator
                    configuratorTitle={item.configuratorName}
                    products={item.cartProducts.map((cartProduct) => cartProduct.product)}
                    totalPrice={unitPrice}
                    btnCustomClass={styles.configuratorIncludedBtn}
                    observations={item.configurator?.includedProductsObservation}
                />
            </Col>
            <Col xs={6} md={3}>
                <span className={styles.priceLabel}>
                    PRET UNITAR <span>(CU TVA):</span>
                </span>
                <br />
                <span className={styles.price}>{unitPrice} Lei</span>
            </Col>
            <Col xs={5} md={2}></Col>
            <Col xs={1} md={1} className={styles.remove}>
                <FaTimes className={styles.deleteIcon} onClick={() => handleDeleteItem(item.configuratorCode)} />
            </Col>
        </Row>
    );
});

export default ConfiguratorItemRow;
